export const AUTH_TOKENS_STORAGE_KEY = 'auth_tokens';
export const AUTH_PERSIST_KEY = 'auth_persist';
